import { render, staticRenderFns } from "./EditarVideos.vue?vue&type=template&id=29fe83c2&scoped=true&"
import script from "./EditarVideos.vue?vue&type=script&lang=js&"
export * from "./EditarVideos.vue?vue&type=script&lang=js&"
import style0 from "./EditarVideos.vue?vue&type=style&index=0&id=29fe83c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29fe83c2",
  null
  
)

export default component.exports